import { Inline, xcss } from '@atlaskit/primitives';
import React from 'react';

type IconWithTextProps = {
  itemText: string | undefined;
  children: React.ReactNode;
};

const IconAndTextContainer = xcss({
  gap: 'space.100',
});

export const IconWithText = ({ itemText, children }: IconWithTextProps) => {
  return (
    <Inline xcss={IconAndTextContainer} alignBlock="center">
      {children}
      {itemText}
    </Inline>
  );
};
